import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';

const ConfirmedButtons = ({
	handleCheckPaymentStatusClick,
	handleAnotherPaymentClick,
	handleGoToAccountsClick,
	accountsButtonLabel,
	anotherPaymentButtonLabel,
	paymentStatusButtonLabel,
}) => (
	<div className="u-margin-top-2">
		<ButtonGroup>
			<Button
				id="goToAccountsButton"
				display="secondary"
				className="u-margin-right-1"
				onClick={handleGoToAccountsClick}
			>
				{accountsButtonLabel}
			</Button>
			<Button
				id="makeAnotherPaymentButton"
				display="secondary"
				className="u-margin-right-1"
				onClick={handleAnotherPaymentClick}
			>
				{anotherPaymentButtonLabel}
			</Button>
			<Button id="checkPaymentStatusButton" display="secondary" onClick={handleCheckPaymentStatusClick}>
				{paymentStatusButtonLabel}
			</Button>
		</ButtonGroup>
	</div>
);

ConfirmedButtons.propTypes = {
	handleCheckPaymentStatusClick: PropTypes.func.isRequired,
	handleAnotherPaymentClick: PropTypes.func.isRequired,
	handleGoToAccountsClick: PropTypes.func.isRequired,
	accountsButtonLabel: PropTypes.string.isRequired,
	anotherPaymentButtonLabel: PropTypes.string.isRequired,
	paymentStatusButtonLabel: PropTypes.string.isRequired,
};

export default ConfirmedButtons;
